export default {
  custom: () => import("C:/Users/Viktor/Development/asufin-app-v2/layouts/custom.vue").then(m => m.default || m),
  default: () => import("C:/Users/Viktor/Development/asufin-app-v2/layouts/default.vue").then(m => m.default || m)
}